import styled from 'styled-components'
import { Flex } from 'grid-styled'
import theme from '../../theme'
import { HashLink as Link } from 'react-router-hash-link'

export const Hamburger = styled(Flex)`
  position: fixed;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  margin-top: 20px;
  margin-left: calc(100% - 60px);
  margin-right: 20px;
  width: 40px;
  line-height: 40px;
  font-size: 40px;
  color: lightgray;
  &:hover {
    color: darkgray;
    cursor: default;
  }
`

export const SideMenu = styled(Flex)`
  width: 100%;
  padding: 20px 30px;
  height: 100%;
  background-color: transparent;
  flex-direction: column;
  align-items: flex-end;
  display: ${props => props.display};
`

export const Links = styled(Flex)`
  flex-direction: column;
  align-items: flex-end;
`

export const Title = styled.h1`
  color: lightgray;
  font-family: ${theme.fonts.primary.family};
`

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: lightgray;
  padding: 10px 0px 0px 0px;
  font-size: 20px;
  font-family: ${theme.fonts.primary.family};
  &:hover {
    color: ${theme.colors.white};
  }
`

export const X = styled(Flex)`
  padding: 5px 0 0 0;
  line-height: 24px;
  font-size: 24px;
  color: lightgray;
  &:hover {
    color: darkgray;
  }
`

export const Dash = styled.hr`
  height: 1px;
  width: 100%;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 30px 0 10px 0;
`



// WEBPACK FOOTER //
// ./src/components/SideBar/styles.js